
// import React, { useState } from 'react';
// import Spacing from '../Spacing';
// import SectionHeadingStyle3 from '../SectionHeading/SectionHeadingStyle3';
// import PostStyle4 from '../Post/PostStyle4';
// import { pageTitle } from '../../helpers/PageTitle';
// import CtaStyle2 from '../Cta/CtaStyle2';
// import AboutStyle7 from '../About/AboutStyle7';
// import AboutStyle8 from '../About/AboutStyle8';
// import PostVideoCard from './Shop/PostVideoCard';

// const blogData = [
//     {
//         // thumbnailSrc: '/images/blog/post_1.jpeg',
//         videoUrl: 'https://www.youtube.com/watch?v=v3hJw7HEWkY&t=4700s',
//         category: 'Branding',
//         title: 'Strategies for building a strong brand identity',
//         subTitle:
//             'From social media to SEO, branding to lead generation, our team of experienced marketers shares their expertise and industry knowledge to help you stay ahead of the curve...',
//         href: '/blog/blog-details',
//     },
//     {
//         // thumbnailSrc: '/images/blog/post_2.jpeg',
//         videoUrl: 'https://www.youtube.com/watch?v=v3hJw7HEWkY&t=4700s',
//         category: 'LifeStyle',
//         title: 'Best SEO practices for better web page rankings',
//         subTitle:
//             'From social media to SEO, branding to lead generation, our team of experienced marketers shares their expertise and industry knowledge to help you stay ahead of the curve...',
//         href: '/blog/blog-details',
//     },
//     {
//         // thumbnailSrc: '/images/blog/post_3.jpeg',
//         videoUrl: 'https://www.youtube.com/watch?v=v3hJw7HEWkY&t=4700s',
//         category: 'Travel',
//         title: 'Strategies for building a strong brand identity',
//         subTitle:
//             'From social media to SEO, branding to lead generation, our team of experienced marketers shares their expertise and industry knowledge to help you stay ahead of the curve...',
//         href: '/blog/blog-details',
//     },
//     {
//         // thumbnailSrc: '/images/blog/post_4.jpeg',
//         videoUrl: 'https://www.youtube.com/watch?v=v3hJw7HEWkY&t=4700s',
//         category: 'Event',
//         title: 'Strategies for building a strong brand identity',
//         subTitle:
//             'From social media to SEO, branding to lead generation, our team of experienced marketers shares their expertise and industry knowledge to help you stay ahead of the curve...',
//         href: '/blog/blog-details',
//     },
//     {
//         // thumbnailSrc: '/images/blog/post_5.jpeg',
//         videoUrl: 'https://www.youtube.com/watch?v=v3hJw7HEWkY&t=4700s',
//         category: 'Tech',
//         title: 'Inspiration for creating compelling visuals',
//         subTitle:
//             'From social media to SEO, branding to lead generation, our team of experienced marketers shares their expertise and industry knowledge to help you stay ahead of the curve...',
//         href: '/blog/blog-details',
//     },
//     {
//         // thumbnailSrc: '/images/blog/post_1.jpeg',
//         videoUrl: 'https://www.youtube.com/watch?v=v3hJw7HEWkY&t=4700s',
//         category: 'Branding',
//         title: 'Strategies for building a strong brand identity',
//         subTitle:
//             'From social media to SEO, branding to lead generation, our team of experienced marketers shares their expertise and industry knowledge to help you stay ahead of the curve...',
//         href: '/blog/blog-details',
//     },
//     {
//         // thumbnailSrc: '/images/blog/post_2.jpeg',
//         videoUrl: 'https://www.youtube.com/watch?v=v3hJw7HEWkY&t=4700s',
//         category: 'LifeStyle',
//         title: 'Best SEO practices for better web page rankings',
//         subTitle:
//             'From social media to SEO, branding to lead generation, our team of experienced marketers shares their expertise and industry knowledge to help you stay ahead of the curve...',
//         href: '/blog/blog-details',
//     },
//     {
//         // thumbnailSrc: '/images/blog/post_3.jpeg',
//         videoUrl: 'https://www.youtube.com/watch?v=v3hJw7HEWkY&t=4700s',
//         category: 'Travel',
//         title: 'Strategies for building a strong brand identity',
//         subTitle:
//             'From social media to SEO, branding to lead generation, our team of experienced marketers shares their expertise and industry knowledge to help you stay ahead of the curve...',
//         href: '/blog/blog-details',
//     },
//     {
//         // thumbnailSrc: '/images/blog/post_4.jpeg',
//         videoUrl: 'https://www.youtube.com/watch?v=v3hJw7HEWkY&t=4700s',
//         category: 'Event',
//         title: 'Strategies for building a strong brand identity',
//         subTitle:
//             'From social media to SEO, branding to lead generation, our team of experienced marketers shares their expertise and industry knowledge to help you stay ahead of the curve...',
//         href: '/blog/blog-details',
//     },
//     {
//         // thumbnailSrc: '/images/blog/post_5.jpeg',
//         videoUrl: 'https://www.youtube.com/watch?v=v3hJw7HEWkY&t=4700s',
//         category: 'Tech',
//         title: 'Inspiration for creating compelling visuals',
//         subTitle:
//             'From social media to SEO, branding to lead generation, our team of experienced marketers shares their expertise and industry knowledge to help you stay ahead of the curve...',
//         href: '/blog/blog-details',
//     },
// ];
// // const blogData = [
// //     {
// //         videoUrl: 'https://www.youtube.com/watch?v=v3hJw7HEWkY&t=4700s',
// //         category: 'Branding',
// //         title: 'Strategies for building a strong brand identity',
// //         subTitle: 'From social media to SEO, branding to lead generation...',
// //         href: '/blog/blog-details',
// //     },
// //     {
// //         videoUrl: 'https://www.youtube.com/watch?v=dQw4w9WgXcQ',
// //         category: 'Branding',
// //         title: 'Strategies for building a strong brand identity',
// //         subTitle: 'From social media to SEO, branding to lead generation...',
// //         href: '/blog/blog-details',
// //     },
// //     {
// //         videoUrl: 'https://www.youtube.com/watch?v=dQw4w9WgXcQ',
// //         category: 'Branding',
// //         title: 'Strategies for building a strong brand identity',
// //         subTitle: 'From social media to SEO, branding to lead generation...',
// //         href: '/blog/blog-details',
// //     },
// //     {
// //         videoUrl: 'https://www.youtube.com/watch?v=dQw4w9WgXcQ',
// //         category: 'Branding',
// //         title: 'Strategies for building a strong brand identity',
// //         subTitle: 'From social media to SEO, branding to lead generation...',
// //         href: '/blog/blog-details',
// //     },
// //     // ...more items
// // ];

// export default function VideoProductionDesign() {
//     const [itemShow, setItemShow] = useState(4);
//     pageTitle('video production');
//     return (
//         <>
//             <Spacing lg="70" md="70" />
//             <Spacing lg="140" md="80" />
//             <SectionHeadingStyle3
//                 title="Stay up to date with our <br>latest blog post"
//                 subTitle="Video Production"
//                 variant="text-center"
//                 shape="shape_5"
//             />
//             <Spacing lg="75" md="60" />
//             <div className="container">
//                 <div className="row cs_gap_y_60">
//                     <div className="col-lg-12">
//                         {blogData.slice(0, itemShow).map((item, index) => (
//                             <PostVideoCard
//                                 key={index}
//                                 videoUrl={item.videoUrl}
//                                 category={item.category}
//                                 title={item.title}
//                                 subTitle={item.subTitle}
//                                 href={item.href}
//                                 width="960px"
//                                 height="540px"
//                             />
//                         ))}
//                         {blogData.length <= itemShow ? null : (
//                             <div className="text-center">
//                                 <Spacing lg="95" md="50" />
//                                 {/* Uncomment below to enable Load More button */}
//                                 {/* <span
//                   className="cs_btn cs_style_1"
//                   onClick={() => setItemShow(itemShow + 3)}
//                 >
//                   Load More Blog
//                   <span>
//                     <i>
//                       <Icon icon="fa6-solid:arrow-right" />
//                     </i>
//                     <i>
//                       <Icon icon="fa6-solid:arrow-right" />
//                     </i>
//                   </span>
//                 </span> */}
//                             </div>
//                         )}
//                     </div>
//                 </div>
//                 {/* <Spacing lg="150" md="80" /> */}
//             </div>





//             {/* <Spacing lg="70" md="70" />
//             <Spacing lg="140" md="80" /> */}
//             {/* <SectionHeadingStyle3
//                 title="Digital marketing <br/>management"
//                 subTitle="Marketing"
//                 variant="text-center"
//             /> */}
//             {/* <Spacing lg="75" md="60" /> */}

//             <div className="container">
//                 {/* <img
//                     className="cs_casestudy_details_thumb cs_radius_15"
//                     src="/images/others/case_1.jpeg"
//                     alt="Thumb"
//                 /> */}
//                 {/* <div className="cs_height_100 cs_height_lg_60" /> */}
//                 {/* <ul className="cs_case_study_info cs_mp0">
//                     <li>
//                         <p className="mb-0">Client</p>
//                         <h3 className="cs_fs_21 mb-0 cs_semibold">Andreo Bowla</h3>
//                     </li>
//                     <li>
//                         <p className="mb-0">Location </p>
//                         <h3 className="cs_fs_21 mb-0 cs_semibold">United Kindom</h3>
//                     </li>
//                     <li>
//                         <p className="mb-0">Budgets</p>
//                         <h3 className="cs_fs_21 mb-0 cs_semibold">$1330 USD</h3>
//                     </li>
//                     <li>
//                         <p className="mb-0">Completed</p>
//                         <h3 className="cs_fs_21 mb-0 cs_semibold">12 April 2023</h3>
//                     </li>
//                 </ul> */}
//                 {/* <div className="cs_height_100 cs_height_lg_60" /> */}
//                 <div className="row align-items-center cs_gap_y_35">
//                     <div className="col-lg-5">
//                         {/* <img
//                             src="/images/others/case_2.jpeg"
//                             alt="Thumb"
//                             className="cs_radius_15 w-100"
//                         /> */}
//                         <div className="ratio ratio-16x9 cs_radius_15 overflow-hidden">
//                             <iframe
//                                 width="560"
//                                 height="509"
//                                 src="https://www.youtube.com/embed/dQw4w9WgXcQ"
//                                 title="Project Video"
//                                 frameBorder="0"
//                                 allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
//                                 allowFullScreen
//                             ></iframe>
//                         </div>
//                     </div>
//                     <div className="col-lg-6 offset-lg-1">
//                         <h2 className="cs_fs_50">Project Brief :</h2>
//                         <div className="cs_height_15 cs_height_lg_15" />
//                         <p>
//                             Sed ut perspiciatis unde omnis iste natus error sit voluptatem
//                             accusantium loposepas doloremque own laudantium, totam rem
//                             aperiam, eaque ipsa quae ab illo inventore veritatis et quasi
//                             holas architecto beatae vitae dicta sunt explicabo. Nemo enim
//                             ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit,
//                             sed quia environmet consequuntur magni dolores eos qui ratione
//                             mone voluptatem sequi nesciunt. Neque porro quisquam est world
//                             wide.
//                         </p>
//                         <p>
//                             Our team, specializing in strategic digital marketing, partners
//                             with the world's leading brands. Breaking from the norm, we push
//                             boundaries and merge imaginative thinking, consumer behavior, and
//                             data-driven design with advanced technology.
//                         </p>
//                         <div className="cs_height_20 cs_height_lg_10" />
//                         <p className="mb-0">
//                             Website:{' '}
//                             <a href="/" className="cs_accent_color">
//                                 www.zivan.com
//                             </a>
//                         </p>
//                     </div>
//                 </div>
//             </div>
//             <Spacing lg="150" md="80" />
//             <AboutStyle7
//                 title="Challenging part:"
//                 subTitle="Our team, specializing in strategic digital marketing, partners with the world's leading brands. Breaking from the norm, we push boundaries and merge imaginative thinking, consumer behavior, and data-driven design advanced."
//                 featureList={[
//                     { number: '01', text: 'User Experience (UX) Enhancement' },
//                     { number: '02', text: 'Modernization' },
//                     { number: '03', text: 'Mobile Responsiveness' },
//                     { number: '04', text: 'Performance Optimization' },
//                     { number: '05', text: 'Branding Consistency' },
//                     { number: '06', text: 'Content Strategy' },
//                 ]}
//                 // thumbnailSrc="/images/others/case_3.jpeg"
//                 videoSrc="https://www.youtube.com/embed/dQw4w9WgXcQ"
//             />
//             <Spacing lg="150" md="80" />

//             <AboutStyle8
//                 videoSrc="https://www.youtube.com/embed/dQw4w9WgXcQ"
//                 title="Result overview:"
//                 subTitle="Performance testing, specializing in strategic digital marketing..."
//                 grothData={[
//                     { title: 'Performance Increase', percentage: '75' },
//                     { title: 'Loading Speed faster', percentage: '85' },
//                     { title: 'Mobile optimize', percentage: '90' },
//                 ]}
//             />
//             <Spacing lg="140" md="70" />
//             <CtaStyle2
//                 title="Is there a specific project or goal <br />that you have in mind?"
//                 btnText="Send Message"
//                 btnUrl="/contact"
//             />
//             <div className="cs_height_150 cs_height_lg_80" />

//         </>
//     );
// }


//----------------------------

// import React, { useState } from 'react';
// import Spacing from '../Spacing';
// import SectionHeadingStyle3 from '../SectionHeading/SectionHeadingStyle3';
// import PostStyle4 from '../Post/PostStyle4';
// import { Icon } from '@iconify/react';
// import Sidebar from '../Sidebar';
// import { pageTitle } from '../../helpers/PageTitle';
// const blogData = [
//   {
//     thumbnailSrc: '/images/blog/post_1.jpeg',
//     category: 'Branding',
//     title: 'Strategies for building a strong brand identity',
//     subTitle:
//       'From social media to SEO, branding to lead generation, our team of experienced marketers shares their expertise and industry knowledge to help you stay ahead of the curve...',
//     href: '/blog/blog-details',
//   },
//   {
//     thumbnailSrc: '/images/blog/post_2.jpeg',
//     category: 'LifeStyle',
//     title: 'Best SEO practices for better web page rankings',
//     subTitle:
//       'From social media to SEO, branding to lead generation, our team of experienced marketers shares their expertise and industry knowledge to help you stay ahead of the curve...',
//     href: '/blog/blog-details',
//   },
//   {
//     thumbnailSrc: '/images/blog/post_3.jpeg',
//     category: 'Travel',
//     title: 'Strategies for building a strong brand identity',
//     subTitle:
//       'From social media to SEO, branding to lead generation, our team of experienced marketers shares their expertise and industry knowledge to help you stay ahead of the curve...',
//     href: '/blog/blog-details',
//   },
//   {
//     thumbnailSrc: '/images/blog/post_4.jpeg',
//     category: 'Event',
//     title: 'Strategies for building a strong brand identity',
//     subTitle:
//       'From social media to SEO, branding to lead generation, our team of experienced marketers shares their expertise and industry knowledge to help you stay ahead of the curve...',
//     href: '/blog/blog-details',
//   },
//   {
//     thumbnailSrc: '/images/blog/post_5.jpeg',
//     category: 'Tech',
//     title: 'Inspiration for creating compelling visuals',
//     subTitle:
//       'From social media to SEO, branding to lead generation, our team of experienced marketers shares their expertise and industry knowledge to help you stay ahead of the curve...',
//     href: '/blog/blog-details',
//   },
//   {
//     thumbnailSrc: '/images/blog/post_1.jpeg',
//     category: 'Branding',
//     title: 'Strategies for building a strong brand identity',
//     subTitle:
//       'From social media to SEO, branding to lead generation, our team of experienced marketers shares their expertise and industry knowledge to help you stay ahead of the curve...',
//     href: '/blog/blog-details',
//   },
//   {
//     thumbnailSrc: '/images/blog/post_2.jpeg',
//     category: 'LifeStyle',
//     title: 'Best SEO practices for better web page rankings',
//     subTitle:
//       'From social media to SEO, branding to lead generation, our team of experienced marketers shares their expertise and industry knowledge to help you stay ahead of the curve...',
//     href: '/blog/blog-details',
//   },
//   {
//     thumbnailSrc: '/images/blog/post_3.jpeg',
//     category: 'Travel',
//     title: 'Strategies for building a strong brand identity',
//     subTitle:
//       'From social media to SEO, branding to lead generation, our team of experienced marketers shares their expertise and industry knowledge to help you stay ahead of the curve...',
//     href: '/blog/blog-details',
//   },
//   {
//     thumbnailSrc: '/images/blog/post_4.jpeg',
//     category: 'Event',
//     title: 'Strategies for building a strong brand identity',
//     subTitle:
//       'From social media to SEO, branding to lead generation, our team of experienced marketers shares their expertise and industry knowledge to help you stay ahead of the curve...',
//     href: '/blog/blog-details',
//   },
//   {
//     thumbnailSrc: '/images/blog/post_5.jpeg',
//     category: 'Tech',
//     title: 'Inspiration for creating compelling visuals',
//     subTitle:
//       'From social media to SEO, branding to lead generation, our team of experienced marketers shares their expertise and industry knowledge to help you stay ahead of the curve...',
//     href: '/blog/blog-details',
//   },
// ];

// export default function VideoProductionDesign() {
//   const [itemShow, setItemShow] = useState(4);
//   pageTitle('video production');
//   return (
//     <>
//       <Spacing lg="70" md="70" />
//       <Spacing lg="140" md="80" />
//       <SectionHeadingStyle3
//         title="Stay up to date with our <br>latest blog post"
//         subTitle="Recent Blog"
//         variant="text-center"
//         shape="shape_5"
//       />
//       <Spacing lg="75" md="60" />
//       <div className="container">
//         <div className="row cs_gap_y_60">
//           <div className="col-lg-8">
//             {blogData.slice(0, itemShow).map((item, index) => (
//               <PostStyle4
//                 key={index}
//                 thumbnailSrc={item.thumbnailSrc}
//                 category={item.category}
//                 title={item.title}
//                 subTitle={item.subTitle}
//                 href={item.href}
//               />
//             ))}
//             {blogData.length <= itemShow ? (
//               ''
//             ) : (
//               <div className="text-center">
//                 <Spacing lg="95" md="50" />
//                 {/* <span
//                   className="cs_btn cs_style_1"
//                   onClick={() => setItemShow(itemShow + 3)}
//                 >
//                   Load More Blog
//                   <span>
//                     <i>
//                       <Icon icon="fa6-solid:arrow-right" />
//                     </i>
//                     <i>
//                       <Icon icon="fa6-solid:arrow-right" />
//                     </i>
//                   </span>
//                 </span> */}
//               </div>
//             )}
//           </div>
//           <div className="col-lg-3 offset-lg-1">
//             <Sidebar />
//           </div>
//         </div>
//         <Spacing lg="150" md="80" />
//       </div>
//     </>
//   );
// }


//----------------------------------------------

// import React, { useState } from 'react';
// import Spacing from '../Spacing';
// import SectionHeadingStyle3 from '../SectionHeading/SectionHeadingStyle3';
// import PostStyle4 from '../Post/PostStyle4';
// import { pageTitle } from '../../helpers/PageTitle';
// import CtaStyle2 from '../Cta/CtaStyle2';
// import AboutStyle7 from '../About/AboutStyle7';
// import AboutStyle8 from '../About/AboutStyle8';
// import PostVideoCard from './Shop/PostVideoCard';

// const blogData = [
//     {
//         // thumbnailSrc: '/images/blog/post_1.jpeg',
//         videoUrl: 'https://youtu.be/_ElB7D7W9Uc',
//         category: 'Product Ad',
//         title: 'Crafting Immersive Experience Through Product Film',
//         subTitle:
//             'A product ad film created for a VR headset, focused on highlighting key features and user experience through immersive visuals and sharp storytelling while keeping the messaging clear, engaging, and product-focused — a strong addition to our tech and product marketing portfolio...',
//         href: '/blog/blog-details',
//     },
//     {
//         // thumbnailSrc: '/images/blog/post_2.jpeg',
//         videoUrl: 'https://youtu.be/6Gc2n2UrR8w',
//         category: 'Walkthrough',
//         title: 'A Walkthrough That Captures More Than Just Space',
//         subTitle:
//             ' A walkthrough video created to highlight the space, services, and atmosphere of the detailing studio. The focus was on smooth visuals, natural pacing, and a clean narrative flow — helping potential clients get a feel for the experience, while adding depth and variety to our video portfolio.',
//         href: '/blog/blog-details',
//     },
//     {
//         // thumbnailSrc: '/images/blog/post_1.jpeg',
//         videoUrl: 'https://youtu.be/cd3FECTLQdw',
//         category: 'E-comm',
//         title: 'Selling with Style: Our Take on E-Comm Content',
//         subTitle:
//             'A product ad crafted specifically for e-commerce platforms, designed to showcase features quickly and clearly. With platform-optimized framing, fast-paced editing, and focused visuals, the video speaks directly to purchase-ready audiences.',
//         href: '/blog/blog-details',
//     },
//     {
//         // thumbnailSrc: '/images/blog/post_1.jpeg',
//         videoUrl: 'https://youtu.be/NSCyOprIS5c',
//         category: 'Campaign Ad',
//         title: 'No Brief? No Problem. Full-Circle Creative for Godrej',
//         subTitle:
//             'A promo video for a social campaign by Godrej, built entirely from the ground up. With no script, footage, or voiceover provided, we developed the concept, sourced impactful visuals, crafted the narrative, and delivered a complete video that aligned with the campaign’s vision — showcasing our end-to-end creative and strategic capabilities.',
//         href: '/blog/blog-details',
//     },
//     {
//         // thumbnailSrc: '/images/blog/post_1.jpeg',
//         videoUrl: 'https://youtu.be/CMJZGFLKux8',
//         category: 'Music Video',
//         title: 'Numberkari Unleashed: Where Visuals Hit as Hard as the Bars',
//         subTitle:
//             ' we brought Numberkari by MC Gawthi to life with a music video that hits with raw energy, sharp edits, and a visual rhythm that moves with every beat. At Brandgazm, we don’t just shoot music videos — we direct visual experiences that amplify the artist’s voice, elevate the track’s vibe, and keep the audience locked in from the first frame to the final fade.',
//         href: '/blog/blog-details',
//     }, 
//     {
//         // thumbnailSrc: '/images/blog/post_1.jpeg',
//         videoUrl: 'https://youtube.com/shorts/AQZT_IzRmf8',
//         category: 'Concert',
//         title: 'Experience Diljit Dosanjh Live: Cinematic Excellence',
//         subTitle:
//             'Dive into the electrifying energy of Diljit Dosanjh’s live concert captured with cinematic excellence. This reel showcases expertly crafted editing and stunning visuals that bring every moment to life — from the vibrant crowd to the artist’s magnetic performance. Experience the perfect blend of storytelling and technical mastery that transforms the concert into an unforgettable visual journey.',
//         href: '/blog/blog-details',
//     },
//     {
//         // thumbnailSrc: '/images/blog/post_1.jpeg',
//         videoUrl: 'https://youtube.com/shorts/kdlTmc-C-sg',
//         category: 'Ad Campaign',
//         title: 'Fashion Meets Film: The Max IYKYDK Experience',
//         subTitle:
//             'Step into the world of Max Fashion’s IYKYDK campaign with stunning cinematic shots and next-level editing that elevate every frame. This reel captures the essence of style and attitude through vibrant visuals and seamless transitions, creating a bold and unforgettable brand experience. Watch as fashion meets film craft in a way that truly speaks to the modern trendsetter.',
//         href: '/blog/blog-details',
//     },
//     {
//         // thumbnailSrc: '/images/blog/post_1.jpeg',
//         videoUrl: 'https://youtube.com/shorts/DPaqbXcrNAo',
//         category: 'UGC Ad',
//         title: 'Expertly Curated UGC Reels to Amplify Your Reach',
//         subTitle:
//             'We specialize in transforming authentic user-generated content into engaging, high-impact ad reels that truly connect with your audience. By showcasing real customer experiences and moments, our expertly crafted UGC videos bring your brand story to life with genuine emotion and credibility. Let us help you amplify your reach and build trust through compelling visual storytelling that feels both authentic and dynamic.',
//         href: '/blog/blog-details',
//     },



// ];

// export default function VideoProductionDesign() {
//     // const [itemShow, setItemShow] = useState(4);
//     const itemShow = blogData.length;

//     pageTitle('video production');
//     return (
//         <>
//             <Spacing lg="70" md="70" />
//             <Spacing lg="140" md="80" />
//             <SectionHeadingStyle3
//                 title="The Perfect Blend of <br> Creativity and Cinematic Excellence"
//                 subTitle="Video Production"
//                 variant="text-center"
//                 shape="shape_5"
//             />
//             <Spacing lg="75" md="60" />
//             <div className="container">
//                 <div className="row cs_gap_y_60">
//                     <div className="col-lg-12">
//                         {/* {blogData.slice(0, itemShow).map((item, index) => (
//                             <PostVideoCard
//                                 key={index}
//                                 videoUrl={item.videoUrl}
//                                 category={item.category}
//                                 title={item.title}
//                                 subTitle={item.subTitle}
//                                 href={item.href}
//                                 width="960px"
//                                 height="540px"
//                             />
//                         ))} */}
//                         {blogData.slice(0, itemShow).map((item, index) => (
//                             <PostVideoCard
//                                 key={index}
//                                 videoUrl={item.videoUrl}
//                                 category={item.category}
//                                 title={item.title}
//                                 subTitle={item.subTitle}
//                                 href={item.href}
//                                 width="100%"
//                                 height="400px"
//                                 reverse={index % 2 !== 0} // Alternate left-right
//                             />
//                         ))}

//                         {blogData.length <= itemShow ? null : (
//                             <div className="text-center">
//                                 <Spacing lg="95" md="50" />

//                             </div>
//                         )}
//                     </div>
//                 </div>
//                 {/* <Spacing lg="150" md="80" /> */}
//             </div>
//         </>
//     );
// }


//-------------


import React, { useState } from 'react';
import Spacing from '../Spacing';
import SectionHeadingStyle3 from '../SectionHeading/SectionHeadingStyle3';
import PostStyle4 from '../Post/PostStyle4';
import { pageTitle } from '../../helpers/PageTitle';
import CtaStyle2 from '../Cta/CtaStyle2';
import AboutStyle7 from '../About/AboutStyle7';
import AboutStyle8 from '../About/AboutStyle8';
import PostVideoCard from './Shop/PostVideoCard';

const blogData = [
    {
        // thumbnailSrc: '/images/blog/post_1.jpeg',
        videoUrl: 'https://youtu.be/_ElB7D7W9Uc',
        category: 'Product Ad',
        title: 'Crafting Immersive Experience Through Product Film',
        subTitle:
            'A product ad film created for a VR headset, focused on highlighting key features and user experience through immersive visuals and sharp storytelling while keeping the messaging clear, engaging, and product-focused — a strong addition to our tech and product marketing portfolio...',
            href: '/video-production',
        },
    {
        // thumbnailSrc: '/images/blog/post_2.jpeg',
        videoUrl: 'https://youtu.be/6Gc2n2UrR8w',
        category: 'Walkthrough',
        title: 'A Walkthrough That Captures More Than Just Space',
        subTitle:
            ' A walkthrough video created to highlight the space, services, and atmosphere of the detailing studio. The focus was on smooth visuals, natural pacing, and a clean narrative flow — helping potential clients get a feel for the experience, while adding depth and variety to our video portfolio.',
            href: '/video-production',
        },
    {
        // thumbnailSrc: '/images/blog/post_1.jpeg',
        videoUrl: 'https://youtu.be/cd3FECTLQdw',
        category: 'E-comm',
        title: 'Selling with Style: Our Take on E-Comm Content',
        subTitle:
            'A product ad crafted specifically for e-commerce platforms, designed to showcase features quickly and clearly. With platform-optimized framing, fast-paced editing, and focused visuals, the video speaks directly to purchase-ready audiences.',
            href: '/video-production',
        },
    {
        // thumbnailSrc: '/images/blog/post_1.jpeg',
        videoUrl: 'https://youtu.be/NSCyOprIS5c',
        category: 'Campaign Ad',
        title: 'No Brief? No Problem. Full-Circle Creative for Godrej',
        subTitle:
            'A promo video for a social campaign by Godrej, built entirely from the ground up. With no script, footage, or voiceover provided, we developed the concept, sourced impactful visuals, crafted the narrative, and delivered a complete video that aligned with the campaign’s vision — showcasing our end-to-end creative and strategic capabilities.',
            href: '/video-production',
        },
    {
        // thumbnailSrc: '/images/blog/post_1.jpeg',
        videoUrl: 'https://youtu.be/CMJZGFLKux8',
        category: 'Music Video',
        title: 'Numberkari Unleashed: Where Visuals Hit as Hard as the Bars',
        subTitle:
            ' we brought Numberkari by MC Gawthi to life with a music video that hits with raw energy, sharp edits, and a visual rhythm that moves with every beat. At Brandgazm, we don’t just shoot music videos — we direct visual experiences that amplify the artist’s voice, elevate the track’s vibe, and keep the audience locked in from the first frame to the final fade.',
            href: '/video-production',
        }, 
    {
        // thumbnailSrc: '/images/blog/post_1.jpeg',
        videoUrl: 'https://youtube.com/shorts/AQZT_IzRmf8',
        category: 'Concert',
        title: 'Experience Diljit Dosanjh Live: Cinematic Excellence',
        subTitle:
            'Dive into the electrifying energy of Diljit Dosanjh’s live concert captured with cinematic excellence. This reel showcases expertly crafted editing and stunning visuals that bring every moment to life — from the vibrant crowd to the artist’s magnetic performance. Experience the perfect blend of storytelling and technical mastery that transforms the concert into an unforgettable visual journey.',
        href: '/video-production',
    },
    {
        // thumbnailSrc: '/images/blog/post_1.jpeg',
        videoUrl: 'https://youtube.com/shorts/kdlTmc-C-sg',
        category: 'Ad Campaign',
        title: 'Fashion Meets Film: The Max IYKYDK Experience',
        subTitle:
            'Step into the world of Max Fashion’s IYKYDK campaign with stunning cinematic shots and next-level editing that elevate every frame. This reel captures the essence of style and attitude through vibrant visuals and seamless transitions, creating a bold and unforgettable brand experience. Watch as fashion meets film craft in a way that truly speaks to the modern trendsetter.',
            href: '/video-production',
        },
    {
        // thumbnailSrc: '/images/blog/post_1.jpeg',
        videoUrl: 'https://youtube.com/shorts/DPaqbXcrNAo',
        category: 'UGC Ad',
        title: 'Expertly Curated UGC Reels to Amplify Your Reach',
        subTitle:
            'We specialize in transforming authentic user-generated content into engaging, high-impact ad reels that truly connect with your audience. By showcasing real customer experiences and moments, our expertly crafted UGC videos bring your brand story to life with genuine emotion and credibility. Let us help you amplify your reach and build trust through compelling visual storytelling that feels both authentic and dynamic.',
            href: '/video-production',
        },



];

export default function VideoProductionDesign() {
    // const [itemShow, setItemShow] = useState(4);
    const itemShow = blogData.length;

      // Sort shorts first, then regular videos (based on videoUrl)
      const sortedBlogData = [...blogData].sort((a, b) => {
        const isShortA = a.videoUrl.includes('youtube.com/shorts');
        const isShortB = b.videoUrl.includes('youtube.com/shorts');
        return isShortB - isShortA; // Shorts come first
    });


    pageTitle('video production');
    return (
        // <>
        //     <Spacing lg="70" md="70" />
        //     <Spacing lg="140" md="80" />
        //     <SectionHeadingStyle3
        //         title="The Perfect Blend of <br> Creativity and Cinematic Excellence"
        //         subTitle="Video Production"
        //         variant="text-center"
        //         shape="shape_5"
        //     />
        //     <Spacing lg="75" md="60" />
        //     <div className="container">
        //         <div className="row cs_gap_y_60">
        //             <div className="col-lg-12">
        //                 {/* {blogData.slice(0, itemShow).map((item, index) => (
        //                     <PostVideoCard
        //                         key={index}
        //                         videoUrl={item.videoUrl}
        //                         category={item.category}
        //                         title={item.title}
        //                         subTitle={item.subTitle}
        //                         href={item.href}
        //                         width="960px"
        //                         height="540px"
        //                     />
        //                 ))} */}
        //                 {blogData.slice(0, itemShow).map((item, index) => (
        //                     <PostVideoCard
        //                         key={index}
        //                         videoUrl={item.videoUrl}
        //                         category={item.category}
        //                         title={item.title}
        //                         subTitle={item.subTitle}
        //                         href={item.href}
        //                         width="100%"
        //                         height="400px"
        //                         reverse={index % 2 !== 0} // Alternate left-right
        //                     />
        //                 ))}

        //                 {blogData.length <= itemShow ? null : (
        //                     <div className="text-center">
        //                         <Spacing lg="95" md="50" />

        //                     </div>
        //                 )}
        //             </div>
        //         </div>
        //         {/* <Spacing lg="150" md="80" /> */}
        //     </div>
        // </>
        <>
        <Spacing lg="70" md="70" />
        <Spacing lg="140" md="80" />
        <SectionHeadingStyle3
            title="The Perfect Blend of <br> Creativity and Cinematic Excellence"
            subTitle="Video Production"
            variant="text-center"
            shape="shape_5"
        />
        <Spacing lg="75" md="60" />
        <div className="container">
            <div className="row cs_gap_y_60">
                <div className="col-lg-12">
                    {sortedBlogData.slice(0, itemShow).map((item, index) => (
                        <PostVideoCard
                            key={index}
                            videoUrl={item.videoUrl}
                            category={item.category}
                            title={item.title}
                            subTitle={item.subTitle}
                            href={item.href}
                            width="100%"
                            height="400px"
                            reverse={index % 2 !== 0}
                        />
                    ))}

                    {sortedBlogData.length <= itemShow ? null : (
                        <div className="text-center">
                            <Spacing lg="95" md="50" />
                        </div>
                    )}
                </div>
            </div>
        </div>
    </>
    );
}
